"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortTimeOf = exports.shortDateTimeOf = exports.shortDateOf = exports.monthAbbrDateOf = exports.longDateTimeOf = exports.longDateOf = exports.getFormat = exports.format = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var prop_1 = __importDefault(require("lodash/fp/prop"));
var utils_1 = require("./utils");
var DateTimeSymbols = __importStar(require("./dateTimeSymbols"));
var DateTimeFormat_1 = require("./DateTimeFormat");
var symbolOf = function (locale) {
    var _a;
    return (_a = (0, prop_1.default)(locale)(DateTimeSymbols)) !== null && _a !== void 0 ? _a : DateTimeSymbols.en_US;
};
/**
 * Format ISO date with given date format.
 *
 * ``` typescript
 * format('yyyy-MM-dd')('1995-12-17T03:24:00');
 * ```
 * */
var format = function (formatStr, locale) { return function (date) {
    var parsedDate = moment_timezone_1.default.parseZone(date, undefined, locale, true);
    return parsedDate.isValid()
        ? parsedDate.format((0, utils_1.parseFormat)(formatStr)
            .replace(/\b(den)\b/gi, '[den]')
            .replace(/\b(de)\b/gi, '[de]'))
        : null;
}; };
exports.format = format;
/**
* Get the predefined format under given locale.
* */
var getFormat = function (target, locale) { return (0, utils_1.parseFormat)(symbolOf(locale).FORMAT[target]); };
exports.getFormat = getFormat;
/**
 * ``` typescript
 * // April 25, 2019
 * ```
* */
var longDateOf = function (locale) { return (0, exports.format)((0, exports.getFormat)(DateTimeFormat_1.DateTimeFormat.LONG_DATE, locale)); };
exports.longDateOf = longDateOf;
/**
* ```typescript
* // April 25, 2019 3:00 am
* ```
* */
var longDateTimeOf = function (locale) { return (0, exports.format)((0, exports.getFormat)(DateTimeFormat_1.DateTimeFormat.LONG_DATETIME, locale)); };
exports.longDateTimeOf = longDateTimeOf;
/**
* ```typescript
* // Apr 25, 2019
* ```
* */
var monthAbbrDateOf = function (locale) { return (0, exports.format)((0, exports.getFormat)(DateTimeFormat_1.DateTimeFormat.MONTH_ABBR_DATE, locale)); };
exports.monthAbbrDateOf = monthAbbrDateOf;
/**
* ```typescript
* // 4/25/2019
* ```
* */
var shortDateOf = function (locale) { return (0, exports.format)((0, exports.getFormat)(DateTimeFormat_1.DateTimeFormat.SHORT_DATE, locale)); };
exports.shortDateOf = shortDateOf;
/**
* ```typescript
* // 4/25/2019 3:00 am
* ```
* */
var shortDateTimeOf = function (locale) { return (0, exports.format)((0, exports.getFormat)(DateTimeFormat_1.DateTimeFormat.SHORT_DATETIME, locale)); };
exports.shortDateTimeOf = shortDateTimeOf;
/**
* ```typescript
* // 08:00 am
* ```
* */
var shortTimeOf = function (locale) { return (0, exports.format)((0, exports.getFormat)(DateTimeFormat_1.DateTimeFormat.SHORT_TIME, locale)); };
exports.shortTimeOf = shortTimeOf;
